<template>
  <div>
    <div class="footer">
      <div class="footer_box">
        <div class="company">
          <img src="@/assets/Nav_bar_logo.png" alt="" />
          <p>© 2023 by 上海杏一医疗用品贸易有限公司</p>
          <br />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >沪ICP备18048607号-1</a
          >
          <br />
          <div style="margin-top:20px;margin-bottom:20px;">
           <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402010147"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
              "
            >
              <img src="@/assets/beian.png" style="float: left" />
              <p
                style="
                  float: left;
                  height: 20px;
                  line-height: 20px;
                  margin: 0px 0px 0px 5px;
                  color: #fff;
                "
              >
                沪公网安备 31010402010147号
              </p>
            </a>
            </div>
        </div>
        <div class="text">
          <!-- <p>若接到可疑電話，請洽詢165反詐騙專線</p>
          <p class="texts">本站最佳瀏覽環境請使用Google Chrome、Firefox或Edge以上版本</p> -->
          <img src="@/assets/QRcodes.jpg" alt="" srcset="" />
          <p>官方公众号</p>
        </div>
      </div>
      <!-- <div class="q" style="margin: 0 auto; padding: 20px 0">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402010147"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
              "
            >
              <img src="@/assets/beian.png" style="float: left" />
              <p
                style="
                  float: left;
                  height: 20px;
                  line-height: 20px;
                  margin: 0px 0px 0px 5px;
                  color: #fff;
                "
              >
                沪公网安备 31010402010147号
              </p>
            </a>
          </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 100%;
  background: #00a4a7;
  .q{
    width: 1220px; 
    @media (max-width: 768px) {
      width: 90%;
    }
  }
  .footer_box {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1220px;
    .company {
      height: 100%;
      margin-bottom: 20px;
      // position: relative;
      > img {
        width: 302px;
        height: 88px;
      }
      a {
        text-decoration: none;
        color: #fff;
        font-size: 16px;
      }
      p {
        // position: absolute;
        // left: 0px;
        // bottom: -4px;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .text {
      margin-top: 25px;
      // width: 100px;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: flex-end;
      align-content: flex-end;
      justify-content: space-around;
      .texts {
        margin-top: 15px;
      }
      p {
        margin: auto;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
      }
      img {
        margin: auto;
        width: 100px;
        height: 100px;
      }
    }
  }
}
@media (max-width: 768px) {
  .footer {
    width: 100%;
    height: 100%;
    background: #00a4a7;
    .footer_box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 auto;
      width: 90%;
      height: 100%;
      .company {
        height: 100%;
        width: 100%;
        margin-bottom: 20px;
        position: relative;
        > img {
          width: 302px;
          height: 88px;
          margin: 0 auto;
        }
        p {
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
        a {
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
        }
      }
      .text {
        margin-top: 0px;
        margin-bottom: 30px;

        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        align-content: flex-end;
        justify-content: space-around;
        .texts {
          margin-top: 0px;
        }
        p {
          margin: auto;
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AppFooter.vue